import React, { useState } from "react";

const ServicesDiagonal = () => {
  const services = [
    {
      title: "Crypto Fraud Prevention",
      desc: "Comprehensive analysis and detection of crypto frauds to protect your investments and identify potential scams before they impact your portfolio.",
      img: "1.jfif",
    },
    {
      title: "Web3 Consultation",
      desc: "Expert guidance on Web3 technologies, decentralized applications, and blockchain integration for businesses and individuals.",
      img: "2.jfif",
    },
    {
      title: "Crypto Portfolio Management",
      desc: "Professional management of your crypto portfolio with strategic allocation, risk assessment, and performance optimization.",
      img: "3.jfif",
    },
    {
      title: "Crypto Mining Consultation",
      desc: "Specialized advice on crypto mining operations, hardware selection, profitability analysis, and mining strategy development.",
      img: "4.jfif",
    },
    {
      title: "Blockchain Consulting",
      desc: "End-to-end blockchain consulting services including architecture design, smart contract development, and implementation strategies.",
      img: "5.jfif",
    },
    {
      title: "Crypto Education and Incident Analysis",
      desc: "Educational programs and detailed analysis of crypto incidents to help you learn from past events and make informed decisions.",
      img: "6.jfif",
    },
  ];

  return (
    <section style={styles.section}>
      {/* 1. Injecting 3D Flip Logic */}
      <style>{`
        .card-container {
          perspective: 1200px;
          cursor: pointer;
          width: 100%;
          max-width: 350px;
          height: 450px;
        }
        .card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transition: transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          transform-style: preserve-3d;
        }
        .card-container.flipped .card-inner {
          transform: rotateY(180deg);
        }
        .card-face {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          border-radius: 30px;
          overflow: hidden;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }
        .card-back {
          transform: rotateY(180deg);
          background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 5px 10px;
          color: white;
          border: 2px solid #7c3aed;
        }
      `}</style>

      <div style={styles.header}>
        <span style={styles.badge}>OUR EXPERTISE</span>
        <h2 style={styles.mainTitle}>Click to Explore</h2>
      </div>

      <div style={styles.grid}>
        {services.map((service, index) => (
          <ServiceCard key={index} service={service} index={index} />
        ))}
      </div>
    </section>
  );
};

// Sub-component to manage individual card state
const ServiceCard = ({ service, index }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`card-container ${flipped ? "flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="card-inner">
        {/* FRONT SIDE (Image Only) */}
        <div className="card-face card-front">
          <div style={styles.imageOverlay}>
            <span style={styles.cardNumber}>0{index + 1}</span>
            <h3 style={styles.cardTitleFront}>{service.title}</h3>
          </div>
          <img
            src={service.img}
            alt={service.title}
            style={styles.image}
            onError={(e) => {
              e.target.src =
                "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&q=80&w=800";
            }}
          />
        </div>

        {/* BACK SIDE (Text Description) */}
        <div className="card-face card-back">
          <div style={styles.accentLine}></div>
          <h3 style={styles.backHeading}>{service.title}</h3>
          <p style={styles.description}>{service.desc}</p>
          <button style={styles.learnMore}>Close Details ×</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  section: {
    padding: "100px 20px",
    backgroundColor: "#f8fafc",
    fontFamily: "'Inter', sans-serif",
    textAlign: "center",
  },
  header: { marginBottom: "60px" },
  badge: {
    color: "#7c3aed",
    fontWeight: "800",
    letterSpacing: "2px",
    fontSize: "22px",
  },
  mainTitle: {
    fontSize: "42px",
    fontWeight: "900",
    color: "#1e293b",
    marginTop: "10px",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  image: { width: "100%", height: "100%", objectFit: "cover" },
  imageOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 60%)",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "30px",
    textAlign: "left",
  },
  cardNumber: { color: "#7c3aed", fontSize: "24px", fontWeight: "900" },
  cardTitleFront: {
    color: "white",
    fontSize: "22px",
    fontWeight: "800",
    marginTop: "5px",
  },
  backHeading: {
    fontSize: "24px",
    fontWeight: "800",
    marginBottom: "15px",
    textAlign: "left",
  },
  accentLine: {
    width: "40px",
    height: "4px",
    backgroundColor: "#7c3aed",
    marginBottom: "20px",
  },
  description: {
    fontSize: "16px",
    color: "#cbd5e1",
    lineHeight: "1.6",
    textAlign: "left",
    marginBottom: "30px",
  },
  learnMore: {
    background: "rgba(124, 58, 237, 0.1)",
    border: "1px solid #7c3aed",
    color: "#7c3aed",
    padding: "10px 20px",
    borderRadius: "10px",
    fontWeight: "700",
    cursor: "pointer",
  },
};

export default ServicesDiagonal;
